const DEFAULT_FIRST_ROUND_TOOLTIP = 'Pre-Championship';
const DEFAULT_OTHER_ROUND_TOOLTIP = 'Pre-Round';

const PROBABILITIES_FIRST_ROUND_TOOLTIP =
    "Pre-Championship probabilities are modeled based on each player's recent performance, golf course difficulty, and the US Open course difficulty. It is a predictive indicator of the percent chance of each outcome.";
const PROBABILITIES_OTHER_ROUND_TOOLTIP =
    "Pre-Round probabilities are modeled based on each player's recent performance, golf course difficulty, and remaining the US Open hole difficulty, as well as other player's relative championship play and latest scores. It is a predictive indicator of the percent chance of each outcome.";

export const PROBABILITY_PAGE_TYPE = {
    LEADERBOARD: 'LEADERBOARD',
    LIVE_VIDEO: 'VIDEO_RECAP',
    PLAYER_COMPARISON: 'PLAYER_COMPARISON',
    PLAYER_DETAIL: 'PLAYER_DETAIL',
};

export function getPreTooltipText(round, type) {
    switch (type) {
        case PROBABILITY_PAGE_TYPE.LEADERBOARD: {
            return Number(round) < 2
                ? PROBABILITIES_FIRST_ROUND_TOOLTIP
                : PROBABILITIES_OTHER_ROUND_TOOLTIP;
        }
        case PROBABILITY_PAGE_TYPE.LIVE_VIDEO: {
            return Number(round) < 2
                ? PROBABILITIES_FIRST_ROUND_TOOLTIP
                : PROBABILITIES_OTHER_ROUND_TOOLTIP;
        }
        default: {
            return Number(round) < 2
                ? DEFAULT_FIRST_ROUND_TOOLTIP
                : DEFAULT_OTHER_ROUND_TOOLTIP;
        }
    }
}
